import { create } from 'zustand';

interface AppStore {
  isOpenDrawer: boolean;
  installEvent: any;
  setInstallEvent: (installEvent: any) => void;
  toggleDrawer: () => void;
  closeDrawer: () => void;
}

const useAppStore = create<AppStore>(set => ({
  isOpenDrawer: false,
  installEvent: null,
  setInstallEvent: installEvent => set(() => ({ installEvent })),
  toggleDrawer: () => set(state => ({ isOpenDrawer: !state.isOpenDrawer })),
  closeDrawer: () => set(() => ({ isOpenDrawer: false })),
}));

export default useAppStore;
